import { MapEvent } from './map-event';
import { MapEventType } from './map-event-type';

export class MapMouseDownEvent implements MapEvent {
    type = MapEventType.mouseDown;
    constructor(public payload: mapboxgl.MapMouseEvent) {}
}
